import CheckIcon from "@mui/icons-material/Check";

import { StepIconProps } from "@mui/material/StepIcon";
import { styled } from "@mui/material";

const StepIconRoot = styled("div")<{
    ownerState: { completed?: boolean; active?: boolean; color?: string };
}>(({ theme, ownerState }) => {
    const { palette } = theme;
    const { completed, active } = ownerState;
    const { dark } = palette;

    return {
        backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
        zIndex: 1,
        color: "#fff",
        width: 50,
        height: 50,
        display: "flex",
        borderRadius: "50%",
        justifyContent: "center",
        alignItems: "center",
        ...(active && {
            backgroundColor: dark.main,
            boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
        }),
        ...(completed && {
            backgroundColor: dark.main,
        }),
    };
});

function StepIcon(props: StepIconProps) {
    const { active, completed, className, color } = props;

    return (
        <StepIconRoot ownerState={{ completed, active, color }} className={className}>
            <CheckIcon />
        </StepIconRoot>
    );
}

export default StepIcon;
